export default __webpack_public_path__ + "static/media/fish.9dae8603.ogg";